import { writable, get, Writable } from 'svelte/store';
import { localStorageWritable } from '@babichjacob/svelte-localstorage';
import { gameStatus, balance } from './index';
import {
    SKIP_WELCOME_SCREEN_STORAGE_KEY,
    USER_SETTINGS__STORAGE_KEY,
    SKIP_FULL_SCREEN_TOOLBAR_IOS_STORAGE_KEY,
    MODAL_TABS
} from '@src/constants';
import { userAgentInfo } from '../utils/global';
import { trackEvent } from '../utils/init-analytics';

// TODO: rename
export const isCrossModalOpened = writable(false);
export const isAutoplayModalOpened = writable(false);
export const isBetModalOpened = writable(false);
export const isIosFullscreenModalOpened = writable(userAgentInfo?.browser.name === 'Mobile Safari');

export const isSlowConnectionDetected = writable(false);
export const uiWidth = writable(0);

export const showBonusGameTransition = writable(true);
export const showTopSlot = writable(true);
export const showHintMultipliers = writable(false);
export const appStarted = writable(false);
export const currentTabMainMenu = writable(MODAL_TABS.SETTINGS);

// welcome screens
export const skipWelcomeScreensAgain = localStorageWritable(SKIP_WELCOME_SCREEN_STORAGE_KEY, false);

// full screen toolbar ios
export const skipFullScreenToolbarAgain = localStorageWritable(SKIP_FULL_SCREEN_TOOLBAR_IOS_STORAGE_KEY, false);

export const showWelcomeScreens = writable(!get(skipWelcomeScreensAgain));
export const showFullScreenToolbarModal = writable(!get(skipFullScreenToolbarAgain));

// user settings: music, sound
export const userSettings: Writable<{
    musicEnabled: boolean;
    soundEnabled: boolean;
}> = localStorageWritable(USER_SETTINGS__STORAGE_KEY, {
    musicEnabled: true,
    soundEnabled: true
}) as Writable<{
    musicEnabled: boolean;
    soundEnabled: boolean;
}>;

export const updateUserSettings = settings => userSettings.update($userSettings => ({ ...$userSettings, ...settings }));

export const toggleAllSounds = value => {
    userSettings.update($userSettings => ({
        ...$userSettings,
        musicEnabled: !value,
        soundEnabled: !value
    }));
};

// hide modals when game started
gameStatus.subscribe($gameStatus => {
    if ($gameStatus === 'STARTED') {
        closeAllModals();
    }
});

isCrossModalOpened.subscribe($isCrossModalOpened => {
    trackEvent('system_menu_state', {
        system_menu_status: $isCrossModalOpened ? 'open' : 'close',
        balance: get(balance)
    });
});

// @TODO add handler on ESC
// @TODO make a general wrapper for modal, so as not to depend on other components
export const closeAllModals = () => {
    isAutoplayModalOpened.set(false);
    isBetModalOpened.set(false);
    isCrossModalOpened.set(false);
};

// hack to detect initial slow app loading (if loading > 5s)
const slowpoke = setTimeout(() => isSlowConnectionDetected.set(true), 5000);
window.addEventListener('load', () => clearTimeout(slowpoke), false);
